import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ClockIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 1.36526C11.866 1.36526 15 4.49927 15 8.36526C15 12.2313 11.866 15.3653 8 15.3653C4.13401 15.3653 1 12.2313 1 8.36526C1 4.49927 4.13401 1.36526 8 1.36526ZM8 4.36526C7.55786 4.36526 7.25 5.95105 7.25 6.36526V8.36526C7.25 8.77947 7.58579 9.11526 8 9.11526L8.97545 9.11465C10.0284 9.10868 13 9.04495 13 8.36526C13 7.61526 9.16421 7.61526 8.75 7.61526V6.36526C8.75 5.95105 8.44214 4.36526 8 4.36526Z"
		/>
	</svg>
))
